export default {
    button: {
        marginTop: 20
    },
    textfield: {
        width: 400
    }
}



// WEBPACK FOOTER //
// ./src/Components/Login/LoginStyles.jsx